import { confirmDialog } from 'primereact/confirmdialog';
import { getUnsavedChanges, setUnsavedChanges } from './unsavedChanges';

const withUnsavedChangesGuard = (onAccept: () => void) => {
  const hasChanges = getUnsavedChanges();

  if (!hasChanges) {
    onAccept();
    return;
  }

  confirmDialog({
    message: 'You have unsaved changes. Do you want to continue?',
    header: 'Unsaved Changes',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      setUnsavedChanges(false); // reset after confirmation
      onAccept();
    },
    reject: () => {},
    acceptLabel: 'Yes',
    rejectLabel: 'No'
  });
};

export default withUnsavedChangesGuard;
